import domtoimage from 'dom-to-image';

export const generateAndUploadImage = async ({
  contentRef,
  userData,
  initData,
  setImageUrl,
  setIsLoading,
  dispatch,
  setImageName
}) => {
  console.log('🚀 Запуск generateAndUploadImage с параметрами:', {
    hasContentRef: !!contentRef.current,
    userData,
    hasInitData: !!initData
  });

  try {
    if (!contentRef.current) {
      console.warn('⚠️ contentRef не найден');
      return;
    }

    // Проверяем наличие изображения в БД
    if (userData?.image_name) {
      console.log('🖼️ Найдено существующее изображение:', userData.image_name);
      const existingImageUrl = `${process.env.REACT_APP_WEBAPP_URL}/uploads/${userData.image_name}`;
      console.log('📍 URL существующего изображения:', existingImageUrl);
      setImageUrl(existingImageUrl);
      setIsLoading(false);
      return;
    }

    console.log('🎨 Начинаем генерацию нового изображения...');
    console.log('📐 Размеры элемента:', {
      width: contentRef.current.offsetWidth,
      height: contentRef.current.offsetHeight
    });

    const dataUrl = await domtoimage.toPng(contentRef.current, {
      quality: 0.8,
      height: contentRef.current.offsetHeight,
      width: contentRef.current.offsetWidth,
      style: {
        'font-family': '"Balsamiq Sans"',
        'text-rendering': 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        'background-color': '#000000',
        'display': 'flex',
        'flex-direction': 'column',
        'justify-content': 'space-between',
        'min-height': '100%'
      },
      filter: (node) => {
        console.log('🔍 Проверяем элемент:', node.classList?.toString());
        
        const result = !node.classList?.contains('deadline__actions') && 
                      !node.classList?.contains('header');
        return result;
      }
    });

    console.log('🖼️ Изображение сгенерировано, начинаем сжатие...');

    // Дополнительное сжатие через canvas перед отправкой
    const image = new Image();
    image.src = dataUrl;
    await new Promise((resolve) => { image.onload = resolve; });

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = image.width;
    canvas.height = image.height;
    
    ctx.drawImage(image, 0, 0);
    
    const compressedDataUrl = canvas.toDataURL('image/jpeg', 0.9);
    const response = await fetch(compressedDataUrl);
    const blob = await response.blob();

    console.log('📤 Подготовка к загрузке изображения...');
    const formData = new FormData();
    formData.append('image', blob, 'screenshot.png');
    
    if (!initData) {
      throw new Error('initData not found in Redux store');
    }
    
    console.log('🔑 Добавляем initData');
    formData.append('initData', initData);

    console.log('📡 Отправка запроса на сервер...');
    const uploadResponse = await fetch(`${process.env.REACT_APP_WEBAPP_URL}/api/upload-image`, {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json',
      },
      credentials: 'include',
      redirect: 'follow',
    });

    if (!uploadResponse.ok) {
      const errorData = await uploadResponse.json();
      throw new Error(`Upload failed with status: ${uploadResponse.status}. Details: ${JSON.stringify(errorData)}`);
    }

    const responseData = await uploadResponse.json();
    console.log('📦 Данные ответа:', responseData);

    const { imageUrl, imageName } = responseData;
    
    console.log('🔄 Обновление состояния...');
    setImageUrl(`${process.env.REACT_APP_WEBAPP_URL}${imageUrl}`);
    dispatch(setImageName(imageName));
    setIsLoading(false);

    console.log('✅ Изображение успешно сгенерировано и сохранено:', imageName);

  } catch (error) {
    console.error('❌ Ошибка при генерации изображения:', error);
    console.error('🔍 Детали ошибки:', error.message);
    console.error('📊 Состояние:', { 
      hasContentRef: !!contentRef.current,
      hasUserData: !!userData,
      hasInitData: !!initData,
      userData 
    });
    setIsLoading(false);
  }
}; 